import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { getMissionUrl, getMissionUrlApplyPath, getMissionUrlPath, isMissionApplyUrl } from '~/utils/missionUrl';

export const useMissionUrl = (slug: string) => {
  const { asPath } = useRouter();
  const { businessUnit } = useBusinessUnitContext();

  return useMemo(
    () => ({
      missionUrl: getMissionUrl(businessUnit, slug),
      missionUrlPath: getMissionUrlPath(businessUnit, slug),
      missionUrlApplyPath: getMissionUrlApplyPath(businessUnit, slug),
      isMissionApplyUrl: isMissionApplyUrl(businessUnit, asPath),
    }),
    [slug, businessUnit, asPath],
  );
};
